import { gql } from "@apollo/client";

export const EMAIL_CHANNEL_UPDATE = gql`
  mutation EmailChannelUpdate($id: ID, $input: EmailChannelFieldsLibInput!) {
    emailChannelUpdate(id: $id, input: $input) {
      label
      message
      emailChannel {
        id
        username
        exhibition_type_id
        is_active
        is_visible
        relExhibitionType {
          id
          title
        }
      }
    }
  }
`;
